import type {
  RouteLocationGeneric,
  RouteLocationNormalizedLoaded,
  RouteLocationRaw,
  Router,
} from "vue-router";
import { useAcl } from "vue-simple-acl";

/**
 * Return true if the route has not "meta.can" function or the function returns true.
 * @param route
 * @param router
 * @param to
 * @param from
 * @returns
 */
export function isRouteAuthorized(
  route: RouteLocationRaw,
  router: Router,
  to?: RouteLocationGeneric,
  from?: RouteLocationNormalizedLoaded,
) {
  const path = typeof route === "string" ? route : (route?.path ?? route?.name);

  // get the route from routes corresponding to the redirect path
  const routeFound = router
    .getRoutes()
    .find((route) => route.name === path || route.path === path);

  if (routeFound) {
    if (routeFound.redirect) {
      if (typeof routeFound.redirect === "string") {
        return isRouteAuthorized(routeFound.redirect, router);
      } else if (typeof routeFound.redirect === "function" && to && from) {
        return isRouteAuthorized(routeFound.redirect(to, from), router);
      }
    }

    return (
      !routeFound.meta.can ||
      (typeof routeFound.meta.can === "function" &&
        routeFound.meta.can(undefined, undefined, useAcl().can))
    );
  } else {
    return false;
  }
}
